<template>
  <div class="v-stack h-stretch gap-3">
    <a class="heading-title-2">Projects</a>
    <div class="card light mn">
      <div class="content h-stretch">
        <div class="v-stack h-stretch gap-3" v-if="data">
          <div class="pane-horizontal gap-3">
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>Crew</a>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Pre Production:</div>
                <div class="text-left">
                  {{ format.currency(data.preProduction) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Production:</div>
                <div class="text-left">
                  {{ format.currency(data.production) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Post Production:</div>
                <div class="text-left">
                  {{ format.currency(data.postProduction) }} kč
                </div>
              </div>
            </div>
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <a>Other</a>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Gear:</div>
                <div class="text-left">{{ format.currency(data.gear) }} kč</div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Production Fee:</div>
                <div class="text-left">
                  {{ format.currency(data.productionFee) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Travel:</div>
                <div class="text-left">
                  {{ format.currency(data.travel) }} kč
                </div>
              </div>
            </div>
          </div>
          <div class="v-stack h-stretch v-start gap-3 card py-5">
            <a>Sum</a>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Crew:</div>
              <div class="text-left">{{ format.currency(data.crew) }} kč</div>
            </div>
            <div class="pane-horizontal gap-3">
              <div class="text-right">Other:</div>
              <div class="text-left">{{ format.currency(data.other) }} kč</div>
            </div>
            <div class="separator"></div>
            <div class="pane-horizontal gap-3" style="font-weight: bold">
              <div class="text-right">Total:</div>
              <div class="text-left">{{ format.currency(data.total) }} kč</div>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="loader"></span>
        </div>
      </div>
    </div>
    <Table
      :loading="loading"
      :items="projects"
      :defaultColumn="2"
      :defaultAscending="true"
      :limit="10"
      :height="360"
      :pageable="true"
      v-on:rowSelected="$router.push('/projects/detail/' + $event._id)"
      css="60px 60px 1fr 80px 80px 200px"
      :columns="[
        {
          name: 'State',
          sort: 'alphabet',
          path: ['state'],
        },
        {
          name: 'Icon',
          sort: 'alphabet',
          path: ['icon'],
        },
        {
          name: 'Project',
          sort: 'alphabet',
          path: ['name'],
        },
        {
          name: 'Created',
          sort: 'date',
          path: ['createdDate'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Deadline',
          sort: 'date',
          path: ['deadline'],
          formatType: 'date',
          format: 'DD.MM.YYYY',
        },
        {
          name: 'Budget',
          sort: 'numeric',
          path: ['budget'],
          format: 'czk',
          formatType: 'currency',
        },
      ]"
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/Table.vue";
import utils from "@/utils.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      data: null,
      projects: [],
      format: utils.format,
      loading: true,
    };
  },
  components: {
    Table,
  },
  methods: {
    ...mapActions(["getOverviewIncome", "getIncomeProjects"]),
    refresh() {
      this.data = null;
      this.loading = true;
      this.getOverviewIncome({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          console.log(error);
        });

      this.getIncomeProjects({
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((projects) => {
          this.projects = projects;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.refresh();
  },
  props: {
    period: {
      type: String,
      default: () => "",
    },
    year: {
      type: String,
      default: () => "",
    },
    month: {
      type: Number,
      default: () => "",
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    period() {
      this.refresh();
    },
    year() {
      this.refresh();
    },
    month() {
      this.refresh();
    },
    startDate() {
      this.refresh();
    },
    endDate() {
      this.refresh();
    },
  },
};
</script>

<style></style>
